var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.isClass},[_c('div',{staticClass:"w"},[_vm._m(0),_c('div',{staticClass:"loading",on:{"click":_vm.handleDownload}},[_vm._v("下载")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left"},[_c('img',{attrs:{"src":"https://wowsite.musicwow.com/mobile_musicwow/image/wow-logo-wx.png","alt":""}}),_c('div',{staticClass:"title"},[_c('h3',[_vm._v("音乐窝")]),_c('p',[_vm._v("多一种沟通方式")])])])
}]

export { render, staticRenderFns }